import { render, staticRenderFns } from "./SupportedNetworksPage.vue?vue&type=template&id=52b9b888&scoped=true&"
import script from "./SupportedNetworksPage.vue?vue&type=script&lang=js&"
export * from "./SupportedNetworksPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b9b888",
  null
  
)

export default component.exports